/**
 *
 * ReleaseOverviewRow
 *
 */

import React, { useContext } from 'react';
import { FormattedMessage } from 'lib/intl';

// intl
import { FormattedDate } from 'lib/intl';

// api
import { Invoice } from 'lib/api/invoice';
import {
  getInvoicePredictionDetailTypeValueFromInvoice,
  InvoicePredictionDetailType,
} from 'lib/api/invoiceDetails';

// ui
import { makeRow } from '@domonda/ui/Row';

// parts
import { ReleaseOverviewContext } from './ReleaseOverview';

const fallback = <span>&mdash;</span>;

const { RowHeader: ReleaseOverviewRowHeader, RowItem: ReleaseOverviewRow } = makeRow<Invoice>({
  columns: [
    {
      width: 32,
      HeaderCell: function HeaderCell() {
        const { invoices, selectedInvoiceIds, onCheckInvoice } = useContext(ReleaseOverviewContext);

        return (
          <input
            type="checkbox"
            checked={
              selectedInvoiceIds.length > 0 &&
              invoices.every(({ InvoiceId }) => selectedInvoiceIds.indexOf(InvoiceId) > -1)
            }
            onChange={onCheckInvoice(undefined)}
          />
        );
      },
      ItemCell: function ItemCell({ item }) {
        const { selectedInvoiceIds, onCheckInvoice } = useContext(ReleaseOverviewContext);

        return (
          <input
            type="checkbox"
            checked={selectedInvoiceIds.indexOf(item.InvoiceId) > -1}
            onChange={onCheckInvoice(item.InvoiceId)}
          />
        );
      },
    },
    {
      width: 64,
      flexGrow: 1,
      HeaderCell: <FormattedMessage id="RELEASE_TYPE" />,
      ItemCell: function ItemCell({ item }) {
        return (
          <span>
            {getInvoicePredictionDetailTypeValueFromInvoice(
              item,
              InvoicePredictionDetailType.DocumentType,
            ) || fallback}
          </span>
        );
      },
    },
    {
      width: 128,
      flexGrow: 1,
      HeaderCell: 'ID',
      ItemCell: function ItemCell({ item }) {
        return (
          <span>
            {getInvoicePredictionDetailTypeValueFromInvoice(
              item,
              InvoicePredictionDetailType.InvoiceId,
            ) || fallback}
          </span>
        );
      },
    },
    {
      width: 96,
      flexGrow: 1,
      HeaderCell: <FormattedMessage id="RELEASE_DATE" />,
      ItemCell: function ItemCell({ item }) {
        return (
          <span>
            <FormattedDate
              value={
                getInvoicePredictionDetailTypeValueFromInvoice(
                  item,
                  InvoicePredictionDetailType.InvoiceDate,
                ) || '—'
              }
            />
          </span>
        );
      },
    },
    {
      width: 96,
      flexGrow: 1,
      HeaderCell: 'VAT ID',
      ItemCell: function ItemCell({ item }) {
        return (
          <span>
            {getInvoicePredictionDetailTypeValueFromInvoice(
              item,
              InvoicePredictionDetailType.VatId,
            ) || fallback}
          </span>
        );
      },
    },
    {
      width: 64,
      flexGrow: 1,
      HeaderCell: <FormattedMessage id="RELEASE_TOTAL" />,
      ItemCell: function ItemCell({ item }) {
        return (
          <span>
            {getInvoicePredictionDetailTypeValueFromInvoice(
              item,
              InvoicePredictionDetailType.GrandTotalAmount,
            ) || fallback}
          </span>
        );
      },
    },
  ],
});

export { ReleaseOverviewRowHeader, ReleaseOverviewRow };
